export default class MobileNavigation {
    constructor() {
      this.navToggle = document.querySelector("#js-toggle-mobile-nav");
      this.panel = document.querySelector("#js-mobile-panel");
      this.panelItems = this.panel.querySelectorAll("a,button");
      this.firstPanelItem = this.panelItems[0];
      this.lastPanelItem = this.panelItems[this.panelItems.length - 1];
      this.init();
    }
  
    init() {
        this.bindEvents();
      }
    
      bindEvents() {
       
        document.addEventListener("keydown", (e) => { 
          if (e.key === "Escape" && this.navToggle.getAttribute("aria-expanded") == "true") {
            e.preventDefault();
            this.close();
          }
        });
    
        this.navToggle.addEventListener("click", () => {
            this.navToggle.getAttribute("aria-expanded") == "false" ? this.open() : this.close();
        });
    
        this.navToggle.addEventListener("keydown", (e) => this.firstPanelItemFocus(e));
    
        this.firstPanelItem.addEventListener("keydown", (e) => { 
          if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            this.close();
            this.navToggle.focus();
          }
        });
    
        this.lastPanelItem.addEventListener("keydown", (e) => { 
          if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            this.close();
            this.navToggle.focus();
          }
        });
    
    
      //   this.panel.ontransitionend = () => {
      //       if (this.navToggle.getAttribute("aria-expanded") == "false") {
      //         if (this.closeDimmer) {
      //           document.dispatchEvent(new CustomEvent("dimmer:close"));
      //         }
      //           this.navToggle.focus();
      //       } 
      //   };
    
      }
    
      firstPanelItemFocus(e) {
        if (e.key === "Tab" && !e.shiftKey && this.panel.classList.contains("is-visible")) {
          e.preventDefault();
          this.firstPanelItem.focus();
        }
      }
    
      open() {
        document.querySelector("html").style.height = "100vh";
        document.querySelector("body").style.overflow = "hidden";
    
        this.navToggle.setAttribute("aria-expanded", true);
        this.panel.classList.add("is-visible");
    
        this.panelItems.forEach((item) => {
          item.tabIndex = 0;
        });
    
      }
    
      close() {
        this.navToggle.setAttribute("aria-expanded", false);
        this.panel.classList.remove("is-visible");
        
        this.panel.querySelectorAll("a,button").forEach((link) => {
            link.tabIndex = -1;
        });
    
        document.querySelector("body").removeAttribute("style");
        document.querySelector("html").removeAttribute("style");
        
      //   this.bodyScrollLock.enableBodyScroll(this.panel);
      }
    
  }